module.exports = __webpack_public_path__ + "media/images/products/icook-mobile-3195b160f0a1918bb3d6659080257431.png";